export const removePipes = (cookie?: string): string | undefined =>
  cookie?.replace(/\|/g, "");

export const getCookie = (name: string): string | undefined =>
  document.cookie
    .split(";")
    .find((cookie) => cookie.includes(name))
    ?.split("=")[1];
